module.exports = __webpack_public_path__ + "static/media/AD.06b42588.png";